import { createBrowserRouter } from 'react-router-dom';

// routes
import AuthenticationRoutes from './AuthenticationRoutes';
import LoginRoutes from './LoginRoutes';
import MainRoutes from './MainRoutes';
import ErrorBoundary from './ErrorBoundary';

// ==============================|| ROUTING RENDER ||============================== //

// Single root route with grouped layout routes (pathless) for different sections.
// This ensures all paths (/login, /dashboard/default, /bookings, /pages/*, /admin/*) are
// properly matched without competing root-level '/' routes that previously caused 404s
// after login for valid protected paths.
const router = createBrowserRouter(
  [
    {
      path: '/',
      errorElement: <ErrorBoundary />, // Provides nice error UI instead of default "Hey developer" 404 screen
      children: [
        // Public/guest auth pages (login, register, etc.) wrapped in Minimal + GuestGuard
        LoginRoutes,
        // Protected app pages (dashboard, bookings, admin) wrapped in MainLayout + AuthGuard
        MainRoutes,
        // Maintenance / error demo pages
        AuthenticationRoutes
      ]
    }
  ],
  {
    basename: import.meta.env.VITE_APP_BASE_NAME
  }
);

export default router;
